import { useDialogInstance } from './useDialogInstance';
import { SxProps } from '../../types';
import { mergeSx } from '../../utils/styling';
import IconButton from '../buttons/IconButton';
import * as Icons from '../icons';

type Props = {
  onClose?: () => void;
  sx?: SxProps;
};

/**
 * @deprecated Old dialog system — the X close button is built into `DialogCard`
 * (used by `DialogV2` / `ConfirmationDialog` / `DestructiveDialog` from `@cast/design-system`).
 * Inside content components, call `useCloseDialog()` directly to close the dialog.
 * To migrate a dialog that uses this, run the `/refactor-dialog <path>` skill.
 */
export const CloseDialogButton = ({ onClose, sx }: Props) => {
  const { destroy } = useDialogInstance();
  if (!onClose && !destroy) {
    return null;
  }

  return (
    <IconButton
      variant="ghost"
      size="sm"
      onClick={onClose || destroy}
      sx={mergeSx({ position: 'absolute', top: 10, right: 8, zIndex: 1 }, sx)}
      testId="close-dialog-button"
    >
      <Icons.X />
    </IconButton>
  );
};
